import React from 'react';
import clsx from 'clsx';

import BlockWrapper from '@/layouts/BlockWrapper/BlockWrapper.component';
import Heading from '@/elements/Heading/Heading.component';
import Text from '@/elements/Text/Text.component';
import Accordion from '@/components/Accordion/Accordion.component';

import { IProps } from '@/blocks/AccordionBlock/AccordionBlock.interface';
import '@/blocks/AccordionBlock/AccordionBlock.styles.css';
import ContentWrapper, { ContentColumn } from '@/layouts/ContentWrapper/ContentWrapper.component';

export const AccordionBlock: React.FC<IProps> = ({
    title,
    description,
    accordionItems,
    className,
    ...blockWrapperProps
}) => {
    return (
        <BlockWrapper
            className={clsx('accordionBlock', className)}
            {...blockWrapperProps}
        >
            <ContentWrapper>
                <ContentColumn>
                    {title && (
                        <Heading level={2} className="accordionBlock__heading" html={title} />
                    )}
                    {description && (
                        <Text className="accordionBlock__description" html={description} />
                    )}
                    <Accordion items={accordionItems} />
                </ContentColumn>
            </ContentWrapper>
        </BlockWrapper>
    );
};

export default AccordionBlock;